import styled from "styled-components";

import { text, transition } from "@ui/helpers";

export const Link = styled.a`
  ${text("regular_14")};
  color: ${({ theme }) => theme.palette.white};
  transition: ${transition(["color"])};

  &:hover {
    color: ${({ theme }) => theme.palette.grey100};
  }
`;
